import React, { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { ServicesSection } from "@/components/ServicesSection";
import { PriceEstimatorSection } from "@/components/PriceEstimatorSection";
import { AboutSection } from "@/components/AboutSection";
import { ReviewsSection } from "@/components/ReviewsSection";
import { DavieAreaSection } from "@/components/DavieAreaSection";
import { BookingCalendarSection } from "@/components/BookingCalendarSection";
import { FAQSection } from "@/components/FAQSection";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { initLazyIframes } from "@/lib/lazyIframe";

const Index = () => {
  // Initialize lazy iframe loading after mount (for reviews widget, etc.)
  useEffect(() => {
    initLazyIframes();
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground font-sans antialiased selection:bg-amber-400 selection:text-slate-950">
      {/* Sticky Header Navigation */}
      <Navbar />

      {/* Main Content Area */}
      <main>
        {/* 1. Hero Banner with Image, CTA, Google Review Proof */}
        <HeroSection />

        {/* 2. Interactive Volume Price Estimator */}
        <PriceEstimatorSection />

        {/* 3. Davie FL Local Services Offered Grid */}
        <ServicesSection />

        {/* 3. About Muscle Junk Removal Team */}
        <AboutSection />

        {/* 4. Google Reviews & Real Social Proof */}
        <ReviewsSection />

        {/* 5. Davie FL Specific Service Area & Zip Code Grid (33314, 33324, 33328, 33330, 33331) */}
        <DavieAreaSection />

        {/* 6. Online Booking Calendar Picker */}
        <BookingCalendarSection />

        {/* 7. Frequently Asked Questions Accordion */}
        <FAQSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating AI Chatbot Widget */}
      <ChatWidget />
    </div>
  );
};

export default Index;
